import { DateTime } from "luxon";

export function isMagicMomentBannerExpired(
  dayState: "day1" | "day2" | undefined,
  expiresAt: string | undefined,
  now: DateTime = DateTime.now(),
) {
  if (dayState !== "day2" || !expiresAt) return false;

  const expiresAtDate = DateTime.fromISO(expiresAt);
  return expiresAtDate.isValid && expiresAtDate < now;
}
